import '../styles/IntegrationsActionStrip.css';
import React from 'react';

function IntegrationsActionStrip() {
  return (
    <section className="ias-strip" aria-labelledby="ias-strip-line">
      <div className="ias-strip__rail" data-content-rail="primary">
        <div className="ias-strip__line">
          <span className="ias-strip__rule" aria-hidden="true" />
          <div>
            <p id="ias-strip-line" className="ias-strip__text">
              Service <strong>configurations are stored locally</strong> on this machine. Brute only
              contacts the <strong>authorized services</strong> you register here — nothing else.
            </p>
            <span className="ias-strip__meta">Local-first · Authorized endpoints only</span>
          </div>
        </div>

        <a className="ias-strip__link" href="/dashboard">
          <span>Return to Dashboard</span>
          <span className="ias-strip__arrow" aria-hidden="true">→</span>
        </a>
      </div>
    </section>
  );
}

export default IntegrationsActionStrip;